<template>
  <v-container grid-list-lg>
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        sm6
        offset-sm3
        md4
        offset-md4
      >
        <v-img :src="logoUrl" />
      </v-flex>

      <v-flex
        xs12
        sm6
        offset-sm3
        md4
        offset-md4
      >
        <elac-login />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ElacLogin from '@/components/ElacLogin.vue';

export default {
  name: 'Home',
  components: { ElacLogin },
  data: () => ({
    logoUrl: `${process.env.BASE_URL}elac-logo.svg`,
  }),
  mounted() {
    this.$store.commit('tenants/reset');
  },
};
</script>
